import { BpeService } from "../../bpe/bpe.service";
import { EventData } from "../../../services/event.service";

export async function runOccurrenceInlineEditScenarios<T>(
    eventId: number,
    change: () => Promise<T>,
    silent?: boolean,
): Promise<T> {
    if (silent) return change();
    return BpeService.runScenarios({
        eventId,
        getSources: () => ["occurrence-inline-edit"],
        change,
    });
}

/** Run occurrence-inline-edit scenarios for changes already saved during silent save. */
export async function runDeferredOccurrenceInlineEditScenarios(
    eventId: number,
    preEventData: EventData,
): Promise<EventData | undefined> {
    let postEventData: EventData | undefined;
    await BpeService.runScenarios({
        eventId,
        getSources: () => ["occurrence-inline-edit"],
        preEventData,
        change: () => Promise.resolve(),
        awaitScenarioCompletion: true,
        onScenarioPostData: (post) => (postEventData = post),
    });
    return postEventData;
}
